
import { GET_DROPDOWN_FOR_PLANTATION_BATCH, UPDATE_USER_OID, GET_USER_DETAILS, UPDATE_STAKEHOLDER_OID, DOWNLOAD_DOCUMENT, UPLOAD_DCUMENT, GET_ADDRESS_BY_PINCODE, authKey, SEND_OTP, VALIDATE_OTP, GET_ADDRESS_BY_IFSC, INSERT_USER_LOGIN, UPDATE_USER_LOGOUT, USER_SIGN_UP_URL, SEND_SIGNUP_LINK, USER_LOGIN_URL, STAKEHOLDER_LOGIN_URL, } from './URLs';
import { loaderService } from './custom-loader/loader-service';
import { getLocalStorageItem } from './localStorageUtils';
import jwt from 'jwt-decode';
import { appInsights } from '../AppInsights';
import apiClient from '../axios';

export const sendOTP = (mobileNumber, callback, templateName = "MobileNoOTPVerification") => {
    //var response = { isSuccess: true };
    //callback(response);
    loaderService.showLoader();
    apiClient.post(SEND_OTP,
        {
            "mobile": mobileNumber,
            "templateType": templateName,
            "userName": localStorage.getItem('userName')
        },
        {
            headers: {
                AuthKey: authKey,
            },
        }
    )
        .then((response) => {
            loaderService.hideLoader();
            callback(response.data);
        })
        .catch(function (error) {
            console.log(error);
            loaderService.hideLoader();
        });
};

export const validateOTP = (mobileNumber, OTP, callback, templateName = "MobileNoOTPVerification") => {

    if (process.env.REACT_APP_ENV == "production") {
        loaderService.showLoader();
        apiClient.post(VALIDATE_OTP,
            {
                "mobile": mobileNumber,
                "otp": OTP,
                "templateType": templateName
            },
            {
                headers: {
                    AuthKey: authKey,
                },
            }
        )
            .then((response) => {
                loaderService.hideLoader();
                callback(response.data)
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }
    else {
        var response = { isSuccess: false };
        if (OTP == "111111") {
            var response = { isSuccess: true };
        }
        callback(response);
    }

};

export const getBambooSpecies = (callback) => {
    apiClient
        .post(
            GET_DROPDOWN_FOR_PLANTATION_BATCH,
            {

            },
            {
                headers: {
                    Authorization: "Bearer " + getLocalStorageItem('id_token'),
                },
            },
            null
        )
        .then((response) => {
            callback(
                response.data.Bamboo_species.map((item) => {
                    return (
                        { ...item, id: (item.id).toLowerCase() }
                    )
                })
            );
        })
        .catch(function (error) {
            console.log(error);
        });
}
export const getBankDetails = (ifscCode, callback) => {
    loaderService.showLoader();
    apiClient.post(GET_ADDRESS_BY_IFSC,
        {
            "ifsc": ifscCode,
        },
        {
            headers: {
                AuthKey: authKey,
            },
        }
    )
        .then((response) => {
            loaderService.hideLoader();
            callback(response.data);
        })
        .catch(function (error) {
            loaderService.hideLoader();
            console.log(error);
        });
}


export const getPincodeAddressDetails = (pincode, callback) => {
    loaderService.showLoader()
    apiClient
        .post(GET_ADDRESS_BY_PINCODE,
            {
                "pincode": pincode,
            },
            {
                headers: {
                    AuthKey: authKey,
                },
            }
        )
        .then((response) => {
            loaderService.hideLoader()
            callback(response.data);
        })
        .catch(function (error) {
            console.log(error);
            loaderService.hideLoader()
        });
}
export const uploadDocument = (selectedFile, type, callback, containerName) => {
    loaderService.showLoader();
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("fileName", selectedFile.name);
    formData.append("containerName", containerName ? containerName : "stakeholder");
    apiClient
        .post(
            UPLOAD_DCUMENT,
            formData,
            {
                headers: {
                    AuthKey: authKey,
                },
            }
        )
        .then((response) => {
            loaderService.hideLoader()
            callback(response.data, type);
        })

        .catch(function (error) {
            console.log(error);
            loaderService.hideLoader()
        });
}
export const downloadDocument = (blobFileName, filename, callback, containerName) => {
    loaderService.showLoader()
    return fetch(DOWNLOAD_DOCUMENT,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                AuthKey: authKey,
            },
            body: JSON.stringify({
                "fileName": blobFileName,
                "containerName": containerName ? containerName : "stakeholder",
                "file": ""
            })
        })
        .then((response) => {
            return response.blob();
        })
        .then((blob) => {
            const splittedName = filename.split('.')
            const fileExtension = splittedName[splittedName.length - 1].toLowerCase();
            let fileType;
            switch (fileExtension) {
                case 'pdf':
                    fileType = 'application/pdf';
                    break;
                case 'png':
                    fileType = 'image/png';
                    break;
                case 'jpg':
                    fileType = 'image/jpeg';
                    break;
                case 'jpeg':
                    fileType = 'image/jpeg';
                    break;
                default:
                    fileType = 'application/octet-stream';
            }
            const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
            const newWindow = window.open(url, '_blank');
            newWindow.focus();
            //const url = URL.createObjectURL(blob);
            //callback(url, filename);
            loaderService.hideLoader();
        })
        .catch(function (error) {
            console.log(error);
            loaderService.hideLoader()
        });

}
export const onSignOut = () => {
    if (getLocalStorageItem('id_token') && getLocalStorageItem('id_token').length > 0) {
        const decoded = jwt(getLocalStorageItem('id_token'));
        const userid = decoded.extension_URN ? decoded.extension_URN : decoded.emails?.[0];
        const ipaddress = localStorage.getItem('ip');
        const id = localStorage.getItem('loginSessionID');
        
        const policy = (decoded.tfp || decoded.acr || '').toLowerCase();

        apiClient
            .post(UPDATE_USER_LOGOUT,
                {
                    "userId": userid,
                    "ipAddress": ipaddress,
                    "id": id
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                clearLocalStorage();
                redirectToB2CLogin(policy);
            })
            .catch(function (error) {
                clearLocalStorage();
                console.log(error);
                redirectToB2CLogin(policy);
            });
    }
    else {
        clearLocalStorage();
        window.location.href = USER_LOGIN_URL; 
    }
};

const redirectToB2CLogin = (policy) => {
    if (policy.includes('stakeholder')) {
        const lang = localStorage.getItem("i18nextLng") || 'en';
        window.location.href = STAKEHOLDER_LOGIN_URL + "&lang=" + lang;
    } else {
        window.location.href = USER_LOGIN_URL;
    }
};

export function clearLocalStorage() {
    localStorage.removeItem("id_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("role");
    localStorage.removeItem("module");
    localStorage.removeItem("uuid");
    localStorage.removeItem("InspectorEmail");
    localStorage.setItem('loginStatus', "false");
    localStorage.removeItem("auth_code");
    localStorage.removeItem('policy');
    localStorage.removeItem('urn');
    localStorage.removeItem('stakeholderCategory');
    localStorage.removeItem('email');
    localStorage.removeItem("growersListData");
    appInsights.clearAuthenticatedUserContext();
    window.location.replace(window.location.origin);
    window.history.replaceState(null, null, "/");

}
export function updateStakeholderADB2CId(urn, oid) {
    apiClient
        .post(UPDATE_STAKEHOLDER_OID,
            {
                "urn": urn,
                "adb2cOid": oid
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }, null
        )
        .then((response) => {
        })
        .catch(function (error) {
            console.log(error);
        });
}
export function updateUserADB2CId(email, oid) {
    apiClient
        .post(UPDATE_USER_OID,
            {
                "userOid": oid,
                "loginEmail": email
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }, null
        )
        .then((response) => {
        })
        .catch(function (error) {
            console.log(error);
        });
}
export function getUserDetails(emailId, callback) {
    apiClient
        .post(GET_USER_DETAILS,
            {
                "emailAddress": emailId,
                "userRole": localStorage.getItem('role')
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }, null
        )
        .then((response) => {
            callback(response.data);
        })
        .catch(function (error) {
            console.log(error);
        });
}
export function insertUserLogin(userid, ipaddress) {
    apiClient
        .post(INSERT_USER_LOGIN,
            {
                "userId": userid,
                "ipAddress": ipaddress
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }, null
        )
        .then((response) => {
            localStorage.setItem('loginSessionID', response.data.userLogin.id);
        })
        .catch(function (error) {
            console.log(error);
        });
}
export function updateUserLogout(userid, ipaddress, id) {
    apiClient
        .post(UPDATE_USER_LOGOUT,
            {
                "userId": userid,
                "ipAddress": ipaddress,
                "id": id
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }, null
        )
        .then((response) => {
        })
        .catch(function (error) {
            console.log(error);
        });
}
export const sendSignupLink = (email, callBack) => {
    loaderService.showLoader();
    apiClient.post(SEND_SIGNUP_LINK,
        {
            "to": [email],
            "replaceTexts": {
                "SignUpUrl": USER_SIGN_UP_URL + "&email=" + email
            },
            "templateName": "USER_SIGNUP_EMAIL"
        },
        {
            headers: {
                AuthKey: authKey,
            },
        }
    )
        .then((response) => {
            loaderService.hideLoader();
            callBack(response);
        })
        .catch(function (error) {
            console.log(error);
            loaderService.hideLoader();
        });
}
